import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import InputBase from '@material-ui/core/InputBase';
import Icon from '@material-ui/core/Icon';
//import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import {
    isEmpty, CellType, DicVal, ByteLeft, toStringDate, isNumber, PadZero, FormatDate, isDate, Floor,
    tagformat, replaceall, getInteferPointLength, getFirstDigits, toStringYYYY, isEnabled
} from '../modules/appLibrary';
import { entryrerender, entrydata } from '../modules/formstore';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

//--------------------------------------------------------
//  Entery Input
//
//  fnc
//  def：カラム情報
//  dataRef : 入力データ
//  textfields : 入力項目リスト（キー制御用）
//--------------------------------------------------------
// Event
//  changewidth
//  ValueChanged
//  ValueChangeing
//  ※データをメモリに保存　rerender防止対策
//--------------------------------------------------------
export default function EntryInput(props) {
    const basestyle = { flex: 1 };
    const inputEl = useRef(null)
    const focusvalue = useRef(null)
    const editStartValue = useRef('')
    const editChangedCalled = useRef(false)
    const pendingMasterRequestKeys = useRef(new Set())

    const formstatus = useSelector(state => state.form.status);
    const warndescription = useSelector(state => state.form.warndiscription);
    const entrylock = useSelector(state => state.form.entryformlock);
    const inputrender = useSelector(state => state.form.entryinputrender);
    const applylinkfield = useSelector(state => state.form.applylinkfield);
    const applyfieldid = useSelector(state => state.form.applyfieldid);
    const account = useSelector(state => state.user.account);
    const [value, setbasevalue] = useState('');
    const [checktext, setText] = useState('');
    const [apptext, setappText] = useState('');
    const [placeholder, setplaceholder] = useState('');
    const [name, setbasename] = useState('');
    const [mark, setmark] = useState(null);
    const [style, setStyle] = useState(basestyle);
    const [warning, setwarning] = useState('');

    const dispatch = useDispatch();

    const CELLTYPE = CellType();
    const elemid = props.def.columnid + "_" + props.def.type;
    const elemcmdid = props.def.columnid + "_cmd_" + props.def.type;

    useEffect(() => {
        if (isEmpty(props.dataRef.current)) return;
        //外部で変更された値を反映
        if (props.def.columnid in props.dataRef.current) {
            if (value !== props.dataRef.current[props.def.columnid]) {
                ShowValue();
            }
        }
    }, [inputrender]);

    useEffect(() => {
        if (isEmpty(props.dataRef.current)) return;
        if (props.def.columnid === applyfieldid) {
            let data = props.dataRef.current;
            if (isEmpty(DicVal(data, applyfieldid, ""))) return;
            LinkFieldApply(props.def, data[applyfieldid]);
        }
    }, [applylinkfield]);

    useEffect(() => {
        if (isEmpty(warndescription)) return;
        let result = warndescription.find(e => e.col === props.def.columnid);
        if (isEmpty(result)) {
            if (!isEmpty(warning)) setwarning("");
            return;
        }
        setwarning(result.message);
    }, [warndescription]);

    useEffect(() => {
        //if (props.def.datatype === CELLTYPE.NUM) {
        //    setStyle({ width: 'auto' });
        //}
        if (props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
            setStyle({ width: 'auto' });
        }
        setplaceholder(Placeholder());
        function Placeholder() {
            var params = DicVal(props.def, "searchparam");
            if (isEmpty(params)) return '';
            return DicVal(params, "placeholder");
        }
    }, [props.def]);

    useEffect(() => {
        ShowValue();
    }, []);

    function resolveChangedDataId(colinfo = props.def, data = props.dataRef.current) {
        const defaultDataId = DicVal(colinfo, "dataid", "");
        const params = DicVal(colinfo, "searchparam", null);
        const chgsearchid = DicVal(params, "chgsearchid", "");
        if (isEmpty(chgsearchid) || isEmpty(data)) return defaultDataId;
        const items = chgsearchid.split(",");
        if (items.length < 2) return defaultDataId;
        const condition = items[0].split("=");
        if (condition.length < 2) return defaultDataId;
        const key = condition[0];
        const expectedValue = condition.slice(1).join("=");
        return String(DicVal(data, key, "")) === expectedValue
            ? items[1].replace("：", ":")
            : defaultDataId;
    }

    function dataid(colinfo = props.def, data = props.dataRef.current) {
        return resolveChangedDataId(colinfo, data);
    }

    function withResolvedDataId(colinfo = props.def, data = props.dataRef.current) {
        const currentDataId = dataid(colinfo, data);
        if (DicVal(colinfo, "dataid", "") === currentDataId) return colinfo;
        return { ...colinfo, dataid: currentDataId };
    }

    function buildMasterRequestKey(colinfo = props.def, code, data = props.dataRef.current) {
        return dataid(colinfo, data) + ":" + String(code);
    }

    function requestMasterData(colinfo, code, others, rowdata, callback, wait) {
        if (isEmpty(code)) {
            callback(null);
            return;
        }
        const sourceData = isEmpty(rowdata) ? props.dataRef.current : rowdata;
        const currentDataId = dataid(colinfo, sourceData);
        const requestKey = buildMasterRequestKey(colinfo, code, sourceData);
        if (pendingMasterRequestKeys.current.has(requestKey)) return;
        pendingMasterRequestKeys.current.add(requestKey);
        props.fnc.current.getMasterdata(currentDataId, code, '', others, rowdata, (data) => {
            pendingMasterRequestKeys.current.delete(requestKey);
            callback(data, requestKey);
        }, wait);
    }

    function isCurrentFieldValue(targetValue, colinfo = props.def) {
        return String(DicVal(props.dataRef.current, colinfo.columnid, "")) === String(isEmpty(targetValue) ? "" : targetValue);
    }

    function useCommittedValueChanged(datatype = props.def.datatype) {
        return datatype === CELLTYPE.CHECK || datatype === CELLTYPE.RADIO;
    }

    function setValue(value) {
        setbasevalue(value);
        if (!isEmpty(props.dataRef.current)) {
            let id = props.def.columnid;
            var data = { ...props.dataRef.current };
            if (isEmpty(data)) data = {};
            if (data[id] === value) return;
            data[id] = value;
            props.dataRef.current = data;
            if (props.def.columnid === id && !useCommittedValueChanged()) {
                ValueChangeing(value, true);
            }
            //newdata[id] = value;
            //props.dataRef.current = newdata;
            //v1.4
            dispatch(entrydata(data));  //コピーを送る
        }
    }
    function setName(name) {
        if (props.def.datatype === CELLTYPE.MASTER) {
            if (!isEmpty(props.dataRef.current)) {
                //MASTERの名称をセット
                let id = props.def.columnid + "_nm";
                var newdata = { ...props.dataRef.current };
                newdata[id] = name;
                props.dataRef.current = newdata;
                //v1.4
                dispatch(entrydata({ ...props.dataRef.current }));  //コピーを送る
            }
        }
       setbasename(name);
    }

    function ShowValue() {
        let data = props.dataRef.current;
        if (props.def.datatype === CELLTYPE.STICKY) {
            if (!isEmpty(data)) {
                let value = data[props.def.columnid];
                if (!isEmpty(value)) {
                    setValue(value.note);
                    setmark({ "mark": value.mark, "color": value.color });
                    return;
                }
            }
            setValue('');
            setmark(null);
        } else if (props.def.datatype === CELLTYPE.CHECK || props.def.datatype === CELLTYPE.RADIO) {
            if (!isEmpty(data)) {
                setValue(data[props.def.columnid])
                SetCheckText(data[props.def.columnid]);
            } else {
                setValue("0");
                SetCheckText("0");
            }
        } else if (props.def.datatype === CELLTYPE.APPROVAL) {
            if (!isEmpty(data)) {
                setValue(data[props.def.columnid])
                SetApprovalText(data[props.def.columnid]);
            } else {
                setValue("0");
                SetApprovalText("0");
                setappText('');
            }
        } else if (props.def.datatype === CELLTYPE.MASTER) {
            if (!isEmpty(data)) {
                setValue(data[props.def.columnid])
                if (!isEmpty(DicVal(data, props.def.columnid + "_nm", "")) && !isEmpty(data[props.def.columnid])) {   //2026/07/28 バックエンドで名称セットされている場合名称を使用
                    setbasename(data[props.def.columnid + "_nm"]);
                } else {
                    ValueFormat(data[props.def.columnid], true);
                }
            } else {
                setValue("");
            }
        } else {
            if (!isEmpty(data)) {
                setValue(data[props.def.columnid])
                ValueFormat(data[props.def.columnid]);
            } else {
                setValue("");
            }
        }
    }
    function applovalenabled() {
        let srcflg = DicVal(props.dataRef.current, props.def.columnid + "_cd", '0'); //元値
        if (srcflg === "0" || srcflg === 0) return true;
        if (!isEmpty(props.def.dbcolumn.split(",")[1])) {
            let appdcd = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[1], '');
            return appdcd === account;
        }
        return false;
    }
    function SetApprovalText(value) {
        let ok = '承認';
        let ng = '否認';
        let off = '';
        if (!isEmpty(props.def.options)) {
            let item = props.def.options.find(e => e.code === "1");
            if (!isEmpty(item)) ok = item.name;
            item = props.def.options.find(e => e.code === "2");
            if (!isEmpty(item)) ng = item.name;
        }

        let srcflg = DicVal(props.dataRef.current, props.def.columnid + "_cd", '0'); //元値
        let appddate = '';
        if (!isEmpty(props.def.dbcolumn.split(",")[0])) {
            appddate = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[0],'');
        }
        let appdnm = ''
        if (!isEmpty(props.def.dbcolumn.split(",")[0])) {
            appdnm = DicVal(props.dataRef.current, props.def.dbcolumn.split(",")[1] + "_nm", '');
            appdnm = ByteLeft(appdnm, 6);
        }
        if (value === "1" || value === 1) {
            setText(ok);
            if (srcflg === "1" || srcflg === 1) setappText(appdnm + " " + appddate);
            else setappText("");
            return;
        }
        if (value === "2" || value === 2) {
            setText(ng);
            if (srcflg === "2" || srcflg === 2) setappText(appdnm + " " + appddate);
            else setappText("");
            return;
        }
        setText(off);
        setappText('');
    }
    function SetCheckText(value) {
        let on = '';
        let off = '';
        if (!isEmpty(props.def.options)) {
            let item = props.def.options.find(e => e.code === "1");
            if (!isEmpty(item)) on = item.name;
            item = props.def.options.find(e => e.code === "0");
            if (!isEmpty(item)) off = item.name;
        }
        setText(value === "1" || value === 1 ? on : off);
    }
    function onChange(id, value, edit) {
        //変更データをメモリ上に保存
        let data = { ...props.dataRef.current };
        if (isEmpty(data)) data = {};
        if (props.def.datatype === CELLTYPE.STICKY) {
            data[id] = {"note":value, "mark": mark===null?'':mark.mark, "color": mark===null?'':mark.color };
        } else {
            if (data[id] === value) return; //2026/5/30
            data[id] = value;
        }
        props.dataRef.current = data;
        if (props.def.columnid === id && !useCommittedValueChanged()) {
            ValueChangeing(value,edit);
        }
    }
    function onMarkChange(id, newmark) {
        //変更データをメモリ上に保存
        let data = { ...props.dataRef.current };
        if (isEmpty(data)) data = {};
        if (props.def.datatype === CELLTYPE.STICKY) {
            data[id] = { "note": value, "mark": newmark === null ? '' : newmark.mark, "color": newmark === null ? '' : newmark.color };
        }
        props.dataRef.current = data;
    }

    function isLock() {
        return props.def.locked || entrylock || ((props.def.primary || props.def.unchange) && formstatus === 'ENTRY FORM');
    }
    function onClick() {
        if (isEmpty(inputEl.current)) return;
        inputEl.current.focus();
    }
    function ApprovalClick() {
        if (value !== "0" && value !== 0) {
            if (!applovalenabled()) return;     //承認者以外
        }
        var newvalue = "1";
        if (value === "1" || value === 1) newvalue = "2";
        if (value === "2" || value === 2) newvalue = "0";
        setValue(newvalue);
        SetApprovalText(newvalue);
        onChange(props.def.columnid, newvalue,true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, newvalue);
        focusvalue.current = newvalue;
    }
    function SwitchClick(e) {
        if (isLock()) return;
        var newvalue = "";
        var newname = "";
        if (isEmpty(value)) {
            newvalue = props.def.options[0].code;
            newname = props.def.options[0].name;
        } else {
            var idx = props.def.options.findIndex(e => e.code === value);
            if (props.def.options.length - 1 === idx) {
                newvalue = props.def.options[0].code;
                newname = props.def.options[0].name;
            } else {
                newvalue = props.def.options[idx+1].code;
                newname = props.def.options[idx+1].name;
            }
        }
        setValue(newvalue);
        setName(newname);
        onChange(props.def.columnid, newvalue,true);
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, newvalue, true);
        focusvalue.current = newvalue;
    }
    function ButtonClick() {
        if (!isEmpty(props.QuerySearchClick)) {
            let cancel = false;
            let newdef = props.QuerySearchClick(props.def, cancel);
            if (cancel) return;
            if (newdef !== null) {
                props.fnc.current.searchlistopen({
                    label: newdef.columnnm,
                    multiple: newdef.multiple || newdef.datatype === CELLTYPE.TAG,
                    rowmode: newdef.multiple && newdef.datatype !== CELLTYPE.MASTERREF,
                    data: withResolvedDataId(newdef, props.dataRef.current),
                    doApply: setsearchitem
                });
                return;
            }
        }
        //検索リストOPEN
        let rowdata = { ...props.dataRef.current };
        props.fnc.current.searchlistopen({
            label: props.def.columnnm,
            multiple: props.def.multiple || props.def.datatype === CELLTYPE.TAG,
            rowmode: props.def.multiple && props.def.datatype !== CELLTYPE.MASTERREF,
            data: withResolvedDataId(props.def, rowdata),
            rowdata:rowdata,
            doApply: setsearchitem
        });
    }
    function setsearchitem(e) {
        props.fnc.current.modify();
        const oldvalue = isEmpty(value) ? "" : value;
        var newvalue = e.value;
        if (props.def.datatype === CELLTYPE.TAG) {
            var newtag = tagformat(e.value + " " + value);
            if (value.split(' ').length !== newtag.split(' ').length || isEmpty(value)) {     //TAG追加あり
                setValue(newtag);
                onChange(props.def.columnid, newtag,true);
                newvalue = newtag;
            }
        } else if (props.def.datatype === CELLTYPE.STICKY) {
            const oldmark = mark === null ? "" : mark.mark;
            setmark({ "mark": e.value, "color": e.color });
            onMarkChange(props.def.columnid, e.value);
            notifyValueChanged(e.value, oldmark, true);
        } else if (props.def.datatype === CELLTYPE.DATE) {
            setValue(toStringDate(e.value));
            onChange(props.def.columnid, toStringDate(e.value), true);
        //    if (!isEmpty(props.ValueChanged)) {
        //        props.ValueChanged(props.def.columnid, toStringDate(e.value), true);
        //    }
        } else if (props.def.datatype === CELLTYPE.YEAR) {
            setValue(toStringYYYY(e.value));
            onChange(props.def.columnid, toStringYYYY(e.value), true);
        } else if (props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
            setValue(e.value);
            setName(e.items[0].data.name);
            onChange(props.def.columnid, e.value,true);
            //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, e.value);
        } else if (props.def.datatype === CELLTYPE.MASTERREF) {
            let value = "";
            for (let i = 0; i < e.items.length; i++) {
                if (i !== 0) value += " ";
                value += e.items[i].data[e.datainfo.dbcolumn];
            }
            setValue(value);
            onChange(props.def.columnid, value,true);
            newvalue = value;
        } else if (props.def.history) {
            let value = e.items[0].data["code"];
            setValue(value);
            onChange(props.def.columnid, value,true);
            newvalue = value;
        } else {
            setValue(e.value);
            onChange(props.def.columnid, e.value,true);
            LinkFieldApply(props.def, e.value);
            //if (!isEmpty(props.ValueChanged)) props.ValueChanged(props.def.columnid, e.value);
        }
        if (props.def.datatype !== CELLTYPE.STICKY) {
            notifyValueChanged(newvalue, oldvalue, true);
        }
        props.fnc.current.searchlistclose();
    }
    function LinkFieldApply(colinfo, value) {
        const currentDataId = dataid(colinfo, props.dataRef.current);
        //参照カラムを取得
        let others = colinfo.trigger;
        if (colinfo.datatype === CELLTYPE.MASTER) {
            others = [...colinfo.trigger, ...[{ columnid: colinfo.columnid, dbcolumn: colinfo.dbcolumn }]];
        }
        if (!props.fnc.current.existMaster(currentDataId, value)) {
            //サーバーより情報を取得
            requestMasterData(colinfo, value, others, null, (data) => callback(data, value, colinfo));
        } else {
            if (colinfo.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                let data = props.fnc.current.getMaster(currentDataId, value);
                setValue(data[colinfo.dbcolumn]);
                onChange(colinfo.columnid, data[colinfo.dbcolumn]);
            }
            if (others.length !== 0) {  //関連セットするデータあり
                let data = props.fnc.current.getMaster(currentDataId, value);
                //すべての項目が揃っているかチェック
                let exist = true;
                for (let i = 0; i < others.length; i++) {
                    let key = others[i].dbcolumn;
                    if (key.toUpperCase() === 'NULL') continue;    //ブランクにする設定
                    if (key.indexOf('dbo') !== -1) {
                        key = 'fnc_' + colinfo.columnid;
                    }
                    if (data[key] === undefined) {
                        exist = false; break;
                    }
                }
                if (exist) {
                    setLinkfielddata(colinfo, data);
                } else {
                    //サーバーより情報を取得
                    others = others.filter(e => e.dbcolumn.toUpperCase() !== 'NULL');   //ブランクにするを除外
                    requestMasterData(colinfo, value, others, null, (data) => callback(data, value, colinfo));
                }
            }
        }
    }
    function setLinkfielddata(col, data) {
        if (col.datatype === CELLTYPE.MASTER) {
            if (!isEmpty(data)) {
                let key = col.dbcolumn;
                if (key.indexOf('dbo') !== -1) {
                    key = 'fnc_' + col.columnid;
                }
                setName(data[key]);
            }
            else setName('');
        }
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (col.trigger[i].dbcolumn.toUpperCase() === 'NULL') {
                    //ブランクにする
                    onChange(col.trigger[i].columnid, "");
                    continue;
                }
                if (!isEmpty(data)) {
                    if (col.trigger[i].dbcolumn.indexOf("dbo") !== -1) {
                        onChange(col.trigger[i].columnid, data["fnc_" + col.trigger[i].columnid]);
                    } else {
                        onChange(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]);
                    }
                } else {
                    let coldef = props.textfields.find(e => e.columnid === col.trigger[i].columnid);
                    if (isEmpty(coldef)) continue;
                    //マスタにない場合でロックセルの場合クリア
                    if (coldef.locked) {
                        //他からのトリガをチェック
                        if (ExistTriggerData(col.trigger[i].columnid, col)) {
                            onChange(col.trigger[i].columnid, "");
                        }
                    }
                }
            } catch { }
        }
        //関連項目に変更を通知
        dispatch(entryrerender());
    }
    function ExistTriggerData(colid, col) {
        //指定colidをトリガに持つcolumnidの値がすべてブランクかどうか
        let cols = props.textfields.filter(e => e.trigger.length !== 0 && e.columnid !== col.columnid);
        for (let i = 0; i < cols.length; i++) {
            if (cols[i].trigger.some(e => e.columnid === colid)) {
                if (!isEmpty(DicVal(props.dataRef.current, cols[i].columnid))) return false;
            }
        }
        return true;
    }
    function onInputChange(newvalue) {
        setValue(newvalue);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
    }
    function onCheckChange(newcheck) {
        if (props.def.locked || entrylock) return false;
        const oldvalue = value;
        const newvalue = newcheck ? "1" : "0";
        setValue(newcheck ? "1" : "0");
        SetCheckText(newvalue);
        onChange(props.def.columnid, newvalue, true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        notifyValueChanged(newvalue, oldvalue, true);
        focusvalue.current = newvalue;
    }
    function onRadioChange(newvalue) {
        if (props.def.locked || entrylock) return false;
        const oldvalue = value;
        setValue(newvalue);
        onChange(props.def.columnid, newvalue, true);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        notifyValueChanged(newvalue, oldvalue, true);
        focusvalue.current = newvalue;
        restoreFocus();
    }
    function restoreFocus() {
        window.requestAnimationFrame(() => {
            if (!isEmpty(inputEl.current)) {
                inputEl.current.focus();
                return;
            }
            let focusEl = document.getElementById(elemid);
            if (!isEmpty(focusEl)) focusEl.focus();
        });
    }
    function notifyValueChanged(newvalue, oldvalue = editStartValue.current, force = false) {
        if (isEmpty(props.ValueChanged) || (!force && editChangedCalled.current)) return;
        const beforevalue = isEmpty(oldvalue) ? "" : String(oldvalue);
        const currentvalue = isEmpty(newvalue) ? "" : String(newvalue);
        if (beforevalue === currentvalue) return;
        props.ValueChanged(props.def.columnid, currentvalue, true, beforevalue);
        editChangedCalled.current = true;
    }
    function onKeyDown(e) {
        if (props.def.datatype === CELLTYPE.CHECK && e.keyCode === 32) {
            e.preventDefault();
            onCheckChange(!(value === "1" || value === 1));
            restoreFocus();
            return;
        }
        if (e.keyCode === 13) {
            e.preventDefault();
            if (!(props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.MASTERREF ||
                props.def.datatype === CELLTYPE.MASTERCODE || props.def.datatype === CELLTYPE.MASTERASST)) {
                notifyValueChanged(ValueFormat(e.target.value));
            }
            let key = "";
            var items = props.textfields.filter(e => e.type === props.def.type);
            for (let i = 0; i < items.length; i++) {
                if (items[i].columnid === props.def.columnid) {
                    if (e.shiftKey) {
                        if (i === 0) 
                            key = items[items.length - 1].columnid + "_" + items[items.length - 1].type;
                        else
                            key = items[i - 1].columnid + "_" + items[i - 1].type;
                    } else {
                        if (i === items.length-1)
                            key = items[0].columnid + "_" + items[0].type;
                        else
                            key = items[i + 1].columnid + "_" + items[i + 1].type;
                    }
                    break;
                }
            }
            if (key !== "") {
                try {
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
    function onFocus(e) {
        focusvalue.current = value;
        editStartValue.current = value;
        editChangedCalled.current = false;
        if (props.def.datatype === CELLTYPE.NUM) {
            setValue(replaceall(value, ",", ""));
        }
        inputEl.current.select();
   }
    function onBlur(e) {
        let oldvalue = "";
        if (!isEmpty(props.dataRef.current)) oldvalue = props.dataRef.current[props.def.columnid];
        let change = e.target.value !== oldvalue;
        onChange(props.def.columnid, e.target.value,true);
        //手入力
        let value = e.target.value;
        if (change && (props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.MASTERREF ||
            props.def.datatype === CELLTYPE.MASTERCODE || props.def.datatype === CELLTYPE.MASTERASST)) {
            if (props.def.length !== 0 && props.def.format.indexOf('padzero') !== -1) {
                if (isNumber(value)) {
                    //ゼロサプレス
                    value = PadZero(value, props.def.length);
                    setValue(value);
                    onChange(props.def.columnid, value,true);
                }
            }
            //マスタ連携項目セット
            LinkFieldApply(props.def, value);
        } else {
            value = ValueFormat(e.target.value);
        }
        notifyValueChanged(value);
    }
    function callback(data, value, colinfo = props.def) {
        if (!isEmpty(data) && props.fnc.current !== null) {
            props.fnc.current.setMaster(data);
        }
        props.fnc.current.wait(false);
        if (!isCurrentFieldValue(value, colinfo)) return;
        if (!isEmpty(data)) {
            if (colinfo.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                setName(data[colinfo.dbcolumn]);
            }
        } else {
            setValue("");   //MASTERエラー時ブランク
        }
        setLinkfielddata(colinfo, data);
        ValueChangeing(value);
    }
    function ValueChangeing(newvalue,edit) {
        if (isEmpty(props.ValueChangeing)) return;
        if (isEmpty(focusvalue.current)) {
            props.ValueChangeing(props.def.columnid, newvalue, edit);
            focusvalue.current = newvalue;
        }
        else {
            if (focusvalue.current !== newvalue || edit) {
                props.ValueChangeing(props.def.columnid, newvalue,edit);
                focusvalue.current = newvalue;
            }
        }
    }
    function ValueFormat(value, show) {
        if (props.def.length !== 0 && props.def.format.indexOf('padzero') !== -1) {
            if (isNumber(value)) {
                //ゼロサプレス
                value = PadZero(value, props.def.length);
                setValue(value);
                onChange(props.def.columnid, value);
            }
        }
        if (props.def.datatype === CELLTYPE.DATE) {
            if (!isDate(value)) {
                setValue('');
                onChange(props.def.columnid, "");
                ValueChangeing("");
                return "";
            }
            value = FormatDate(value);
        }
        if (props.def.datatype === CELLTYPE.NUM) {
            if (isEmpty(value)) {
                setValue('');
                onChange(props.def.columnid, "");
                ValueChangeing("");
                return "";
            }
            let num = Floor(Number(value), props.def.decimalplace);
            if (isNaN(num) || num === 0) {
                setValue('');
                onChange(props.def.columnid, "");
                ValueChangeing("");
                return "";
            }
            if (props.def.length !== 0 && props.def.length < getInteferPointLength(num)) {
                //入力桁数が指定桁をオーバーしている場合
                num = getFirstDigits(num, props.def.length)
            }
            let newvalue = "";
            if (props.def.format.indexOf('unuseGrouping') !== -1) { //カンマ区切りなし
                newvalue = num.toString();
            } else {
                if (props.def.decimalplace === 0) {
                    newvalue = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                } else {
                    newvalue = num.toLocaleString(undefined, {
                        minimumFractionDigits: props.def.decimalplace,
                        maximumFractionDigits: props.def.decimalplace
                    });
                }
            }
            setValue(newvalue);
            ValueChangeing(newvalue);
            return newvalue;
        }
        if (props.def.datatype === CELLTYPE.MASTER) {
            if (isEmpty(value)) {
                setName('');
                ValueChangeing("");
                return "";
            }
            const currentDataId = dataid(props.def, props.dataRef.current);
            let others = [{ columnid: props.def.columnid, dbcolumn: props.def.dbcolumn }];
            let data = props.fnc.current.getMaster(currentDataId, value);
            if (data !== null) {
                if (data[props.def.dbcolumn] !== undefined) {
                    setValue(value);
                    setName(data[props.def.dbcolumn]);
                    ValueChangeing(value);
                    return value;
                }
            }
            //サーバーより情報を取得
            let rowdata = null;
            if (!isEnabled(show)) {
                rowdata = { ...props.dataRef.current };
            }
            requestMasterData(props.def, value, others, rowdata, (data) => callback(data, value));
            return value;
        }
        if (props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN) {
            let result = props.def.options.find(e => e.code === value);
            if (!isEmpty(result))
                setName(result.name);
            else {
                value = "";
                setName('');
            }
        }

        if (isEmpty(value)) setValue('');
        else setValue(value);
        ValueChangeing(isEmpty(value)?"":value);
        return isEmpty(value) ? "" : value;
    }


    function SizeChange(e) {
        if (e.shiftKey) {
            e.preventDefault();
            if (!isEmpty(props.changewidth))
                props.changewidth(props.def, e.deltaY);
        }
    }
    function Stickymark() {
        if (props.def.datatype !== CELLTYPE.STICKY) return null;
        if (mark !==null) {
            return <IconButton size="small" onClick={!props.def.locked && !entrylock ? ButtonClick : null}>
                <Icon style={{ color: mark.color }}>{mark.mark}</Icon>
            </IconButton>
        } else {
            return <IconButton size="small" onClick={!props.def.locked && !entrylock ? ButtonClick : null}>
                <Icon>arrow_right</Icon>
            </IconButton>
        }
    }
    function applovalicon(value) {
        if (value === "1" || value === 1) {
            return <Icon style={{ color: '#1ABC9C' }}>verified_user</Icon>
        }
        if (value === "2" || value === 2) {
            return <Icon style={{ color: '#E74C3C' }}>gpp_bad</Icon>
        }
        return <Icon>crop_free</Icon>
    }
    function iconcursor() {
        if (props.def.locked || entrylock) return 'default';
        if (props.def.datatype === CELLTYPE.CHECK) return 'pointer';
        if (applovalenabled()) return 'pointer';
        else return 'not-allowed'
    }
    function InputCheck() {
        let cursor = iconcursor();
        if (props.def.datatype === CELLTYPE.RADIO) {
            return (
                <div style={{ marginLeft:8 }}>
                <RadioGroup
                    row
                    value={isEmpty(value) ? "" : value}
                    onChange={(e) => onRadioChange(e.target.value)}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '12px',
                            lineHeight: 1,
                        },
                        '& .MuiRadio-root': {
                            padding: '2px',
                        },
                        '& .MuiRadio-root.Mui-checked': {
                            color: '#87877c',
                        },
                    }}
                >
                        {(props.def.options || []).map((option, index) => (
                            <FormControlLabel
                                key={option.code}
                                value={option.code}
                                control={
                                    <Radio
                                        size="small"
                                        id={(option.code === value) || (isEmpty(value) && index === 0) ? elemid : undefined}
                                        inputRef={(option.code === value) || (isEmpty(value) && index === 0) ? inputEl : null}
                                        onKeyDown={onKeyDown}
                                    />
                                }
                                label={option.name}
                            />
                        ))}
                    </RadioGroup>
                    </div>
            );            
        }
        if (props.def.datatype === CELLTYPE.CHECK) {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            id={elemid}
                            checked={value === "1" || value === 1}
                            inputRef={inputEl}
                            onKeyDown={onKeyDown}
                            onChange={(e) => onCheckChange(e.target.checked)}
                            onWheel={(e) => SizeChange(e)}
                            size = "small"
                            sx={{
                                p: 0.4,   // Checkbox 自体の余白を小さく
                                marginLeft:1,
                                "&.Mui-checked": {
                                    color: "#87877c",
                                },
                            }}
                        />
                    }
                    label={checktext}
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            fontSize: "12px",
                            userSelect: "none",
                            lineHeight: 1,
                        },
                    }}                />
            );
        }
        return (
            <React.Fragment>
                <IconButton size="small" style={{ marginLeft: 4, cursor: cursor }}
                    onClick={!props.def.locked && !entrylock ? ApprovalClick : null}>
                    {applovalicon(value)}
                </IconButton>
                <InputBase style={style}
                    value={checktext}
                    readOnly={true}
                    inputProps={{
                        style: { textAlign: 'left', fontSize: 12 },
                    }}
                    onWheel={(e) => SizeChange(e)}
                />
                <InputBase style={style}
                    value={apptext}
                    readOnly={true}
                    inputProps={{
                        style: { textAlign: 'right', fontSize: 12, marginRight: 5 },
                    }}
                    onWheel={(e) => SizeChange(e)}
                /> 
            </React.Fragment>
        );
    }
    function WarnTip() {
        return (
            <Tooltip title={warning}>
                <div style={{ position: 'absolute', top: -3, left: -8, cursor: 'pointer' }}>
                    <span class="material-icons warning">announcement</span>
                </div>
            </Tooltip>
        );
    }
   return (
        <div style={{ display: 'flex', position: 'relative' }} onClick={onClick}>
            {warning === "" ? null : <WarnTip />}
           <Stickymark />
           {props.def.datatype !== CELLTYPE.CHECK && props.def.datatype !== CELLTYPE.APPROVAL && props.def.datatype !== CELLTYPE.RADIO ?
               <InputBase style={style}
                   id={elemid}
                   value={value}
                   placeholder={placeholder}
                   readOnly={props.def.locked || entrylock || ((props.def.primary || props.def.unchange) && formstatus === 'ENTRY FORM') ? true : false}
                   inputProps={{
                       maxLength: props.def.length === 0 || props.def.datatype === CELLTYPE.NUM ? null : props.def.length,
                       style: { textAlign: props.def.datatype === CELLTYPE.NUM ? 'right' : 'left', fontSize: 12, marginRight: props.def.datatype === CELLTYPE.NUM ? 15 : 0},
                       autoComplete: 'off'
                   }}
                   onChange={(e) => onInputChange(e.target.value)}
                   onBlur={onBlur}
                   onFocus={onFocus}
                   onKeyDown={onKeyDown}
                   onWheel={(e) => SizeChange(e)}
                   inputRef={inputEl}
               /> :
                <InputCheck />
           }
           {props.def.datatype === CELLTYPE.MASTER || props.def.datatype === CELLTYPE.SELECT || props.def.datatype === CELLTYPE.SPIN ?
                <div style={{ flex: 1, marginLeft: 0, marginTop: 5, color: '#555', whiteSpace: 'nowrap', fontSize:12 }}>{name}</div> : null}
           {props.def.locked || entrylock || ((props.def.primary || props.def.unchange) && formstatus === 'ENTRY FORM') ||
               (!props.def.history &&
               (props.def.datatype === CELLTYPE.TEXT || props.def.datatype === CELLTYPE.TEXTAREA || props.def.datatype === CELLTYPE.NUM ||
                   props.def.datatype === CELLTYPE.STICKY || props.def.datatype === CELLTYPE.CHECK || props.def.datatype === CELLTYPE.APPROVAL || props.def.datatype === CELLTYPE.RADIO))
                ? null :
                <div id={elemcmdid} >
                   {props.def.datatype === CELLTYPE.SPIN ?
                        <IconButton size="small" onClick={() => SwitchClick()}>
                           <Icon>unfold_more</Icon>
                        </IconButton>
                    :
                       <IconButton size="small" onClick={() => ButtonClick()}>
                           <Icon>arrow_right</Icon>
                       </IconButton>
                    }
                </div>
            }
        </div>
    );
}
